/**
 * SHIMMI — formulár „Pridaj príspevok“ (templates/page.feed-submit.liquid).
 *
 * Odošle meno, kontakt, text a nepovinnú fotku na Supabase funkciu `feed-submit`. Príspevok sa
 * nezverejní hneď — najprv ho schváli tím v appke. Fotka sa pred odoslaním zmenší (max 1400 px,
 * JPEG), aby prešla limitom 6 MB; ak sa nedá zmenšiť (napr. HEIC mimo Safari), pošle sa pôvodná.
 */
(function () {
  var form = document.getElementById('shimmi-submit');
  if (!form) return;

  var endpoint = form.getAttribute('data-endpoint');
  var errorBox = form.querySelector('.ss-error');
  var button = form.querySelector('.ss-submit');
  var done = document.querySelector('.ss-done');
  var area = form.querySelector('textarea[name="text"]');
  var count = form.querySelector('[data-ss-count]');
  var MAX_BYTES = 6 * 1024 * 1024;

  area.addEventListener('input', function () {
    count.textContent = String(area.value.length);
  });

  function fail(message) {
    errorBox.textContent = message;
    errorBox.hidden = false;
    errorBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  // Zmenší fotku na max 1400 px (JPEG); pri chybe vráti pôvodný súbor.
  function shrink(file) {
    if (!file || !window.createImageBitmap) return Promise.resolve(file);
    return createImageBitmap(file)
      .then(function (bmp) {
        var scale = Math.min(1, 1400 / Math.max(bmp.width, bmp.height));
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(bmp.width * scale);
        canvas.height = Math.round(bmp.height * scale);
        canvas.getContext('2d').drawImage(bmp, 0, 0, canvas.width, canvas.height);
        return new Promise(function (resolve) {
          canvas.toBlob(function (blob) { resolve(blob || file); }, 'image/jpeg', 0.85);
        });
      })
      .catch(function () { return file; });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorBox.hidden = true;

    var data = new FormData(form);
    var name = String(data.get('name') || '').trim();
    var contact = String(data.get('contact') || '').trim();
    var text = String(data.get('text') || '').trim();
    var photo = data.get('photo');

    if (name.length < 2) return fail('Napíš svoje meno.');
    if (contact.length < 3) return fail('Zadaj e-mail alebo Instagram, aby sme ťa vedeli kontaktovať.');
    if (text.length < 3) return fail('Napíš text príspevku.');
    if (!data.get('consent')) return fail('Potrebujeme tvoj súhlas so zverejnením.');

    button.disabled = true;
    button.textContent = 'Odosielam…';

    var hasPhoto = photo && photo.size > 0;
    (hasPhoto ? shrink(photo) : Promise.resolve(null))
      .then(function (small) {
        if (small && small.size > MAX_BYTES) throw new Error('Fotka je väčšia ako 6 MB.');
        if (hasPhoto) data.set('photo', small, 'photo.jpg');
        else data.delete('photo');
        return fetch(endpoint, { method: 'POST', body: data });
      })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          if (!res.ok) throw new Error(body.error || 'Odoslanie sa nepodarilo, skús to znova.');
          form.hidden = true;
          done.hidden = false;
          done.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      })
      .catch(function (err) {
        fail(err && err.message ? err.message : 'Odoslanie sa nepodarilo, skús to znova.');
        button.disabled = false;
        button.textContent = 'Odoslať';
      });
  });
})();
